<app-header></app-header>

<div class="text-center pd-t-200">
  <h2>You have been banned from room.</h2>
</div>